import { defineStore } from 'pinia';

import type { ConversationResultDTO } from '@nora-monorepo/nora-api-client';
import { useApiStore } from '@nora-monorepo/ui-shared';

export const useOperationConversationStore = defineStore(
  'operationConversationStore',
  () => {
    const api = useApiStore();
    const createOperationConversation = async (
      operationId: string,
      conversationName: string,
    ): Promise<ConversationResultDTO> => {
      conversationName = conversationName.trim();
      if (!conversationName.length) {
        throw new Error('Conversation name is required');
      }

      const result = await api.unwrap(
        api.nexusOperationConversation.createOperationConversation({
          operationId,
          operationConversationCreateDTO: {
            title: conversationName,
          },
        }),
      );

      if (!result.data) {
        throw new Error('Failed to create conversation');
      }

      return result.data;
    };

    return {
      createOperationConversation,
    };
  },
);
